import { Labels } from '../../shared-components/global/labels';

Labels.set('ui-rating', 'rating-singular', 'täht');
Labels.set('ui-rating', 'rating-plural', 'tähte');
